import lib from "./lib.js";
import Player from "@vimeo/player";

class IntlyVideo {
    constructor(root, options = {}) {
        this.root = root;
        this.playObj = lib.qs(".play-pause", this.root);
        this.muteObj = lib.qs(".mute-unmute", this.root);
        this.expandObj = lib.qs(".expand-subtract", this.root);
        this.obj = lib.qs(".video-player", this.root); // Video Player Object Selected
        this.isClose = lib.qs(".--close", this.root);

        // START YOUTUBE FILL
        if(lib.qs(".youtube-player", this.root)) {
            this.videoPlaceholder = lib.qs(".video-placeholder", this.root);
            this.popup = lib.qs(".is-popup", this.root);
            this.overlay = lib.qs(".is-overlay", this.root);

            // Youtube Close Behaviour
            if (this.isClose) {
                this.isClose.addEventListener('click', () => {
                    if (this.popup) {
                        this.popup.classList.remove('open');
                    }
                });
            }


            this.remotePlayBtn1 = lib.qs('.play-pause[data-button="1"]', this.root.parentNode);
            this.remotePlayBtn2 = lib.qs('.play-pause[data-button="2"]', this.root.parentNode);
            this.remotePlayBtn3 = lib.qs('.play-pause[data-button="3"]', this.root.parentNode);

            if (this.videoPlaceholder) {
                this.videoPlaceholder.addEventListener('click', () => {
                    if (this.popup) {
                        this.popup.classList.add('open');
                    }
                });
            }

            if (this.overlay) {
                this.overlay.addEventListener('click', () => {
                    if (this.popup) {
                        this.popup.classList.remove('open');
                    }
                });
            }

            [this.remotePlayBtn1, this.remotePlayBtn2, this.remotePlayBtn3].forEach(elem => {
                elem?.addEventListener("click", () => {
                    this.popup.classList.add('open');
                    this.render();
                });
            });
    

            return;
        }
        // END YOUTUBE FILL
    
        this.autoplay = this.obj.getAttribute("autoplay") === "" ? true : false;
        this.isVimeo = this.obj.classList.contains('vimeo-player');
    
        this.play = options.autoplay !== undefined ? options.autoplay : this.autoplay;
        this.mute = options.muted !== undefined ? options.muted : this.autoplay;
        this.background = options.background !== undefined ? options.background : this.autoplay;
        this.screen = false;
        this.barhover = false;

        this.remotePlayBtn1 = lib.qs('.play-pause[data-button="1"]', this.root.parentNode);
        this.remotePlayBtn2 = lib.qs('.play-pause[data-button="2"]', this.root.parentNode);
        this.remotePlayBtn3 = lib.qs('.play-pause[data-button="3"]', this.root.parentNode);

        // Video Popup
        this.videoPlaceholder = lib.qs(".video-placeholder", this.root);
        this.popup = lib.qs(".is-popup", this.root);
        this.overlay = lib.qs(".is-overlay", this.root);

        if (this.videoPlaceholder) {
            this.videoPlaceholder.addEventListener('click', () => {
                if (this.popup) {
                    this.popup.classList.add('open');
                    this.play = true;
                    this.render();
                }
            });
        }

        if (this.isClose) {
            this.isClose.addEventListener('click', () => {
                if (this.popup) {
                    this.popup.classList.remove('open');
                        this.play = false;
                        this.render();
                }
            });
        }

        if (this.overlay) {
            this.overlay.addEventListener('click', () => {
                if (this.popup) {
                    this.popup.classList.remove('open');
                        this.play = false;
                        this.render();
                }
            });
        }
        // END Video Popup

  
        if (this.isVimeo) {
            
             // Function to get the Vimeo ID without the hash parameter
               
                function hasVimeoHash(vimeoId) {
                    return vimeoId.includes('?h=');
                }

                let v_source = {};

                if(hasVimeoHash(options.id || this.obj.dataset.vimeo)) {
                    console.log('has-hash');
                    v_source = {
                        id: 'https://vimeo.com/video/' + (options.id || this.obj.dataset.vimeo),
                    };
                } else {
                    console.log('no-hash');
                    v_source = {
                        id: (options.id || this.obj.dataset.vimeo)
                    };
                };

    
                    

            // Create Vimeo player
            this.player = new Player(this.obj, {
                //id: options.id || this.obj.dataset.vimeo,
                // url: 'https://vimeo.com/video/' + (options.id || this.obj.dataset.vimeo),
                ...v_source,
                playsinline: options.playsinline || true,
                muted: this.mute,
                controls: options.controls || false,
                byline: options.byline || false,
                autoplay: this.play,
                responsive: options.responsive || true,
                pip: options.pip || false,
                background: this.background,
            });
        } else {
            // Create HTML Player
            this.player = this.obj;
            this.player.muted = this.mute;
            this.player.controls = options.controls || false;
            this.player.autoplay = this.play;
        }
    
        // Init Player
        this.init();
    }
  
    // Init Method
    init() {
      if (this.isVimeo) {
            this.player.ready().then(() => {
                this.root.classList.add("is-ready");
                this.root.dataset.loaded = true;
            });
        } else {
                this.player.addEventListener('loadeddata', () => {
                this.root.classList.add("is-ready");
                this.root.dataset.loaded = true;
            });
        }
    
        this.addEventListeners();
        this.updateProgressBar();
        this.render();
    }
  
    // All Event Listeners
    addEventListeners() {
        this.playObj?.addEventListener("click", () => {
            this.play = !this.play;
            this.render();
        });

        [this.remotePlayBtn1, this.remotePlayBtn2, this.remotePlayBtn3].forEach(elem => {
            elem?.addEventListener("click", () => {
                this.play = !this.play;
                if (this.popup) {
                    this.popup.classList.add('open');
                }
                this.render();
            });
        });


        this.muteObj?.addEventListener("click", () => {
            this.mute = !this.mute;
            this.render();
        });

        this.expandObj?.addEventListener("click", () => {
            this.screen = !this.screen;
            this.render();
        });

        this.obj?.addEventListener("click", () => {
            this.play = !this.play;
            this.render();
        });

        this.obj?.addEventListener("dblclick", () => {
            this.screen = !this.screen;
            this.render();
        });
  
        const bar = lib.qs(".bar .progress", this.root);
        const barroot = lib.qs(".bar-progress", this.root);
  
        if (barroot) {
            barroot.addEventListener("mouseenter", () => {
                this.barhover = true;
            });
    
            barroot.addEventListener("mouseleave", () => {
                this.barhover = false;
            });
    
            barroot.addEventListener("mousemove", (e) => {
                bar.style.width = (e.offsetX * 100) / barroot.offsetWidth + "%";
            });
    
            barroot.addEventListener("click", (e) => {
                const barduration = (e.offsetX * 100) / barroot.offsetWidth;
        
                this.play = true;
                this.render();
        
                if (this.isVimeo) {
                    this.player.getDuration().then((duration) => {
                        this.player.setCurrentTime((barduration / 100) * duration);
                    });
                } else {
                    const duration = this.player.duration;
                    this.player.currentTime = (barduration / 100) * duration;
                }
            });
    
            // Update Hover
            setInterval(() => {
                if (!this.barhover) {
                    if (this.isVimeo) {
                        this.player.getDuration().then((duration) => {
                            this.player.getCurrentTime().then((seconds) => {
                            const percentage = (seconds * 100) / duration;
                                bar.style.width = percentage + "%";
                            });
                        });
                    } else {
                        const duration = this.player.duration;
                        const currentTime = this.player.currentTime;
                        const percentage = (currentTime * 100) / duration;
                        bar.style.width = percentage + "%";
                    }
                }
            }, 50);
            // End Update Hover
        } // END IF BarRoot
  
        let timeout = "";
  
        this.root.addEventListener("mousemove", () => {
            this.root.classList.remove("fadeout");
            clearTimeout(timeout);
  
            timeout = setTimeout(() => {
                this.root.classList.add("fadeout");
            }, 1000);
        });
  
        this.root.addEventListener("mouseleave", () => {
            this.root.classList.remove("fadeout");
            clearTimeout(timeout);
        });
    }
    
    // Update Progress
    updateProgressBar() {
        const bar = lib.qs(".bar .progress", this.root);
        const barroot = lib.qs(".bar-progress", this.root);
    
        if (bar && barroot) {
            setInterval(() => {
                if (!this.barhover) {
                    if (this.isVimeo) {
                        this.player.getDuration().then((duration) => {
                            this.player.getCurrentTime().then((seconds) => {
                            const percentage = (seconds * 100) / duration;
                                bar.style.width = percentage + "%";
                            });
                        });
                    } else {
                        const duration = this.player.duration;
                        const currentTime = this.player.currentTime;
                        const percentage = (currentTime * 100) / duration;
                        bar.style.width = percentage + "%";
                    }
                }
            }, 50);
        }
    }
    // End Update Progress
  
    // Render Method
    render() {
       // Play
        if (this.play) {
            if (this.isVimeo) {
                this.player.play();
            } else {
                this.player.play();
            }
        } else {
            if (this.isVimeo) {
                this.player.pause();
            } else {
                this.player.pause();
            }
        }
        
        if (this.playObj) {
            this.playObj.dataset.status = this.play;
        }
        [this.remotePlayBtn1, this.remotePlayBtn2, this.remotePlayBtn3].forEach(elem => {
            if (elem) {
                elem.dataset.status = this.play;
            }
        });
        this.root.dataset.status = this.play;
    
        // Mute
        if (this.isVimeo) {
            this.player.setVolume(this.mute ? 0 : 1);
        } else {
            this.player.muted = this.mute;
        }

        if (this.muteObj) {
            this.muteObj.dataset.status = this.mute;
        }
    
        //   if (this.screen) {
        //         if (this.root.requestFullscreen) {
        //             this.root.requestFullscreen();
        //             } else if (this.root.mozRequestFullScreen) {
        //             this.root.mozRequestFullScreen();
        //             } else if (this.root.webkitRequestFullscreen) {
        //             this.root.webkitRequestFullscreen();
        //             } else if (this.root.msRequestFullscreen) {
        //             this.root.msRequestFullscreen();
        //             }
        //         } else {
        //             if (document.exitFullscreen) {
        //             document.exitFullscreen();
        //             } else if (document.mozCancelFullScreen) {
        //             document.mozCancelFullScreen();
        //             } else if (document.webkitExitFullscreen) {
        //             document.webkitExitFullscreen();
        //             } else if (document.msExitFullscreen) {
        //             document.msExitFullscreen();
        //         }
        //     }
    
        if (this.expandObj) {
            this.expandObj.dataset.status = this.screen;
        }
        this.root.dataset.fullscreen = this.screen;
    }
  
    destroy() {
        if (this.isVimeo) {
            this.player.destroy().then(() => {
                this.root.classList.remove("is-ready");
                delete this.root.dataset.loaded;
            });
        } else {
            this.player.pause();
            this.player.src = "";
            this.root.classList.remove("is-ready");
            delete this.root.dataset.loaded;
        }
    }
}
  
export { IntlyVideo as default };
